/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogAccountCreationContainer_user$ref: FragmentReference;
declare export opaque type LogAccountCreationContainer_user$fragmentType: LogAccountCreationContainer_user$ref;
export type LogAccountCreationContainer_user = {|
  +userId: ?string,
  +tabs: ?number,
  +$refType: LogAccountCreationContainer_user$ref,
|};
export type LogAccountCreationContainer_user$data = LogAccountCreationContainer_user;
export type LogAccountCreationContainer_user$key = {
  +$data?: LogAccountCreationContainer_user$data,
  +$fragmentRefs: LogAccountCreationContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LogAccountCreationContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "userId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabs",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b6f9dd4cdef87ff3edb837180f889b70';
module.exports = node;
